import Loader from '@/components/Loader';
import bg_bottom from '@img/bg_bottom.png';
import black_dune from '@img/black_dune.png';
import red_dune from '@img/red_dune.png';
import { IRoute } from '@interfaces/IRoutes';
import { UserStatusType } from '@interfaces/IUser';
import { LinksEnum } from '@interfaces/LinksEnum';
import ErrorFallback from '@layouts/Fallback';
import { userLoggedStatus, changeWalletAddress, authNetworkType, setNetworkId, authNetworkId } from '@redux/auth';
import { changeWalletConnect, isWalletConnectActive } from '@/redux/web3';
import { getWalletConnectProvider } from '@/web3/getWeb3';
import { useAppSelector, useAppDispatch } from '@utils/hooks';
import React, { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import MainContent from './components/MainContent';
import logo from './logo.svg';
import VipLevels from './pages/vip_levels';
import { GlobalStyle, useOwnTheme } from '@styles/theme';
import { MainAuthorized, MainUnauthorized } from '@pages/main';
import Deposit from './pages/Deposit';
import PrivateSwap from './pages/PrivateSwap';
import Farming from './pages/Farming';
import Rewards from './pages/Rewards';
import Voting from './pages/Voting';
import Web3 from "web3";
import ReactDOM from 'react-dom';
import { 
  loginUserToWebSite, 
  logoutUserFromWebSite,
  setNetworkType
} from '@/redux/auth';
import { WalletType, NetworkType } from '@/interfaces/IUser';
import { changeNetwork } from './web3/getWeb3'
import NotificationBarWarning, { NotificationBarInfo, NotificationBarError, NotificationBarSuccess, NotificationBarNetwork, NotificationBarTestnet} from '@/components/NotificationBar';
import { supportedIDs } from '@/utils/consts'
import { config } from './sahara-core-config';
import { ApolloProvider } from '@apollo/client';
import { getSubgraphClient } from './utils/subgraph';

const Vesting = React.lazy(() => import('@pages/vesting'));

const routes: {
  [UserStatusType.VISITOR]: IRoute[];
  [UserStatusType.AUTHED]: IRoute[];
} = {
  [UserStatusType.VISITOR]: [
    {
      name: 'My Assets',
      pageTitle: 'AVAILABLE ASSETS',
      path: LinksEnum.MAIN,
      exact: true,
      link: true,
      bgrImg: {
        dark: black_dune,
        light: bg_bottom,
      },
      icon: () => <img alt='main page' src={logo} />,
      main: () => <MainUnauthorized />,
    },
    {
      name: 'Vesting',
      path: LinksEnum.VESTING,
      exact: true,
      link: true,
      bgrImg: {
        dark: red_dune,
        light: bg_bottom,
      },
      icon: () => <img alt='vesting page' src={logo} />,
      main: () => <Vesting />,
    },
    {
      name: 'Vip Levels',
      path: LinksEnum.VIP_LEVELS,
      exact: true,
      link: true,
      icon: () => <img alt='vip levels page' src={logo} />,
      main: () => <VipLevels />,
      comingSoon: true,
    },
    {
      name: 'Deposit/Withdraw',
      path: LinksEnum.DEPOSIT_WITHDRAW,
      exact: true,
      link: true,
      icon: () => <img alt='deposit page' src={logo} />,
      main: () => <Deposit />,
      comingSoon: true,
    },
    {
      name: 'Private Swap',
      path: LinksEnum.PRIVATE_SWAP,
      exact: true,
      link: true,
      icon: () => <img alt='private swap page' src={logo} />,
      main: () => <PrivateSwap />,
      comingSoon: true,
    },
    {
      name: 'Farming',
      path: LinksEnum.FARMING,
      exact: true,
      link: true,
      icon: () => <img alt='farming page' src={logo} />,
      main: () => <Farming />,
      comingSoon: true,
    },
    {
      name: 'Rewards',
      path: LinksEnum.REWARDS,
      exact: true,
      link: true,
      icon: () => <img alt='rewards page' src={logo} />,
      main: () => <Rewards />,
      comingSoon: true,
    },
    {
      name: 'Voting',
      path: LinksEnum.VOTING,
      exact: true,
      link: true,
      icon: () => <img alt='voting page' src={logo} />,
      main: () => <Voting />,
      comingSoon: true,
    },
    {
      name: 'Not Match',
      path: LinksEnum.NOTFOUND,
      link: false,
      main: () => <Redirect to={LinksEnum.MAIN} />,
    },
  ],
  [UserStatusType.AUTHED]: [
    {
      name: 'My Assets',
      path: LinksEnum.MAIN,
      exact: true,
      link: true,
      bgrImg: {
        dark: black_dune,
        light: bg_bottom,
      },
      icon: () => <img alt='main page' src={logo} />,
      main: () => <MainAuthorized />,
    },
    {
      name: 'Vesting',
      path: LinksEnum.VESTING,
      exact: true,
      link: true,
      bgrImg: {
        dark: red_dune,
        light: bg_bottom,
      },
      icon: () => <img alt='vesting page' src={logo} />,
      main: () => <Vesting />,
    },
    {
      name: 'Vip Levels',
      path: LinksEnum.VIP_LEVELS,
      exact: true,
      link: true,
      icon: () => <img alt='vip levels page' src={logo} />,
      main: () => <VipLevels />,
      comingSoon: true,
    },
    {
      name: 'Deposit/Withdraw',
      path: LinksEnum.DEPOSIT_WITHDRAW,
      exact: true,
      link: true,
      icon: () => <img alt='deposit page' src={logo} />,
      main: () => <Deposit />,
      comingSoon: true,
    },
    {
      name: 'Private Swap',
      path: LinksEnum.PRIVATE_SWAP,
      exact: true,
      link: true,
      icon: () => <img alt='private swap page' src={logo} />,
      main: () => <PrivateSwap />,
      comingSoon: true,
    },
    {
      name: 'Farming',
      path: LinksEnum.FARMING,
      exact: true,
      link: true,
      icon: () => <img alt='farming page' src={logo} />,
      main: () => <Farming />,
      comingSoon: true,
    },
    {
      name: 'Rewards',
      path: LinksEnum.REWARDS,
      exact: true,
      link: true,
      icon: () => <img alt='rewards page' src={logo} />,
      main: () => <Rewards />,
      comingSoon: true,
    },
    {
      name: 'Voting',
      path: LinksEnum.VOTING,
      exact: true,
      link: true,
      icon: () => <img alt='voting page' src={logo} />,
      main: () => <Voting />,
      comingSoon: true,
    },
    {
      name: 'Not Match',
      path: LinksEnum.NOTFOUND,
      link: false,
      main: () => <Redirect to={LinksEnum.MAIN} />,
    },
  ],
};

function App(): JSX.Element {
  const location = useLocation();
  const type = useAppSelector(userLoggedStatus);
  const dispatch = useAppDispatch();
  
  const w = (window as unknown) as Window & { ethereum: any; web3: Web3 };
  const walletType : WalletType = WalletType.METAMASK;
  const walletConnect = useAppSelector(isWalletConnectActive)

  function renderWrongNetworkMessage()
  {
    ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar-network") as HTMLElement)
    ReactDOM.render( <NotificationBarNetwork closable={true} text="Warning: You have selected an unsupported network, which may result in loss of 
    functionality. Currently, only Ethereum and Polygon main networks are supported."/>, document.getElementById("notification-bar-network"))
  }
  function renderTestnetNetworkInfoMessage()
  {
    if(document.getElementById("notification-bar-network-testnet")){
      ReactDOM.unmountComponentAtNode(document.getElementById("notification-bar-network-testnet") as HTMLElement)
      ReactDOM.render( <NotificationBarTestnet closable={true} text="This functionality is working only on Ropsten testnet.
      "/>, document.getElementById("notification-bar-network-testnet"))
    }
  }

  function getNetworkType(networkId : number){
    let networkType = 'unsupported';
    if(config.deployments[networkId] && supportedIDs.indexOf(networkId) !== -1){
      networkType = config.deployments[networkId].networkName;
    } 
    return networkType;
  }

  useEffect(() => {
    (async function fetch() {

      if(walletConnect && type == 'auth') {
        const provider = await getWalletConnectProvider();
        const web3 = new Web3(provider);
        const networkId = await web3.eth.net.getId();
        const networkType = getNetworkType(networkId);

        dispatch(setNetworkType(networkType as NetworkType));
        dispatch(setNetworkId(networkId));


        // if(document.readyState === "complete" && supportedIDs.indexOf(networkId) == -1)
        // {
        //   renderWrongNetworkMessage()
        // }
        if(document.readyState === "complete")
        {
          renderTestnetNetworkInfoMessage()
        }
        else {
        document.onreadystatechange = function () {
          // if(document.readyState === "complete" && supportedIDs.indexOf(networkId) == -1){
          //   renderWrongNetworkMessage()
          //    }
             if(document.readyState === "complete")
             {
               renderTestnetNetworkInfoMessage()
             }
        }
      }
                             
        provider.on("disconnect", (code: number, reason: string) => {
          provider.disconnect();
          dispatch(changeWalletConnect(false));
          dispatch(logoutUserFromWebSite());
          });

          provider.on("accountsChanged", async (accounts: string[]) => {
            accounts[0]?dispatch(loginUserToWebSite(WalletType.WALLETCONNECT)):dispatch(logoutUserFromWebSite());
             if(accounts[0]) {
              const web3 = new Web3(provider);
               dispatch(changeWalletAddress(accounts[0]))
        }
      });
    }
            
      else if(w.ethereum && type == 'auth') {
        const web3 = new Web3(w.ethereum);
        // const networkType = await web3.eth.net.getNetworkType();
        const networkId = await web3.eth.net.getId();
        const networkType = getNetworkType(networkId);

        dispatch(setNetworkType(networkType as NetworkType));
        dispatch(setNetworkId(networkId));

        // if(document.readyState === "complete" && supportedIDs.indexOf(networkId) == -1)
        // {
        //   renderWrongNetworkMessage()
        // }
        if(document.readyState === "complete")
        {
          renderTestnetNetworkInfoMessage()
        }
        else {
        document.onreadystatechange = function () {
          // if(document.readyState === "complete" && supportedIDs.indexOf(networkId) == -1){
          //   renderWrongNetworkMessage()
          //    }
             if(document.readyState === "complete")
             {
               renderTestnetNetworkInfoMessage()
             }
        }
      }
        //If account is connected to the platform, but not logged in to metamask - 
        web3.eth.getAccounts(function(err, accounts){
            if (accounts.length == 0 && type == 'auth') {
              // renderAccountErrorMessage();
              dispatch(logoutUserFromWebSite());
            } 
          });  

        w.ethereum.on('chainChanged', async (chainID : any) => {

          const networkId = parseInt(chainID, 16)
          const networkType = getNetworkType(networkId);
          await changeNetwork(chainID, networkId);
          dispatch(setNetworkType(networkType as NetworkType));
          dispatch(setNetworkId(networkId));
          w.location.reload();

        });
        w.ethereum.on('accountsChanged', (accounts : any) => {
          dispatch(loginUserToWebSite(walletType));
          // w.location.reload();
        });
        w.ethereum.on('disconnect', () => {
          console.log("disconnect event triggered")
          // dispatch(logoutUserFromWebSite());
          // w.location.reload();
        });
      }
    })()
  }, [])

  useOwnTheme();

  const networkId : any = useAppSelector(authNetworkId);
  const subghraphClient = getSubgraphClient(networkId);

  // ReactDOM.render(
  //   <ApolloProvider client={subghraphClient}>
  //   </ApolloProvider>,
  //   document.getElementById('root')
  // );


  return (
    <>
          {/* Apollo subgraph warpping */}
  <ApolloProvider client={subghraphClient}>
      <MainContent routes={routes[type]}>
      <div id="notification-bar-network" style={{paddingBottom:'15px'}}>
      </div>
        <SwitchTransition mode="out-in">
          <CSSTransition
            key={location.pathname}
            classNames="my-node"
            timeout={300}
          >
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense fallback={<Loader />}>
                <Switch location={location}>
                  {routes[type].map((route, index) => (
                    <Route key={index} path={route.path} exact={route.exact}>
                      {route.main}
                    </Route>
                  ))}
                </Switch>
              </Suspense>
            </ErrorBoundary>
          </CSSTransition>
        </SwitchTransition>
      </MainContent>
      <GlobalStyle />
  </ApolloProvider>,
    </>
  );
}

export default App;
